import { ScrollContainer } from '~/components/ui/ScrollContainer';
import { rage, useObservable } from '~/rage';
import { LootItem } from '../LootItem';
import { StyledContainer } from './LootList.styled';

const LootList = ({ ...props }: React.HTMLAttributes<HTMLDivElement>) => {
	const items = useObservable(rage.lootBuyers.getSellItems());
	const ownedItems = useObservable(rage.lootBuyers.getOwnedItems());

	return (
		<ScrollContainer height={489} tabIndex={-1} {...props}>
			<StyledContainer>
				{items.map((item) => (
					<LootItem
						name={item.name}
						id={item.id}
						buyerType={item.buyerType}
						itemId={item.itemId}
						count={ownedItems[item.id] ?? 0}
						price={item.price}
						key={item.id}
					/>
				))}
			</StyledContainer>
		</ScrollContainer>
	);
};

export { LootList };
